import { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useInView } from 'react-intersection-observer';
import { Mediator } from '@spotahome/soyuz-mediator';

import SoyuzAnalytics from '@spotahome/soyuz-analytics';
import {
  BILLS_INCLUDED_VALUES,
  ValuePropositionFeatures as ValuePropositionFeaturesList,
  isPlusPlan
} from '@spotahome/ui-library';

import { SHOW_EXTENDED_LANDLORD_INFORMATION } from '@spotahome/marketplace-common/src/channels';

import { usePricingContext } from '@spotahome/marketplace-common/src/context/PricingContext';

import { ListingShape } from '@spotahome/marketplace-common/src/shapes/listing';

import { trans } from '@spotahome/soyuz/client';

import { getBillsIncluded } from '@spotahome/ui-library/src/utils/listing';

import { useLandlordInformation } from '../context/LandlordInformationContext';

const ValuePropositionFeatures = ({ listing }) => {
  const {
    instantBooking,
    checked,
    bills,
    allowsPermanentContract,
    isBestChoice,
    plan,
    runner,
    verificationDate
  } = listing;
  const { isEnabled: instantBookingEnabled, rules } = instantBooking;
  const { landlordInformation } = useLandlordInformation();
  const [valuePropositionRef, inView] = useInView({
    triggerOnce: true,
    threshold: 0.25
  });

  const { hasNoDeposit } = usePricingContext();

  const billsIncluded = getBillsIncluded(bills);

  useEffect(() => {
    if (inView) {
      SoyuzAnalytics.sendGA4Event('value-proposition-visible', {});
    }
  }, [inView]);

  const handleLandlordTypeClick = () => {
    Mediator.publish(SHOW_EXTENDED_LANDLORD_INFORMATION);
  };

  return (
    <ValuePropositionFeaturesList
      ref={valuePropositionRef}
      isChecked={checked}
      landlordInformation={landlordInformation}
      hasNoDeposit={hasNoDeposit}
      isInstantBookingEnabled={instantBookingEnabled}
      isBillsIncluded={billsIncluded === BILLS_INCLUDED_VALUES.all}
      isSomeBillsIncluded={billsIncluded === BILLS_INCLUDED_VALUES.some}
      instantBookingRules={rules}
      onLandlordTypeClick={handleLandlordTypeClick}
      isPlus={isPlusPlan(plan)}
      isLongTerm={allowsPermanentContract}
      isBestChoice={isBestChoice}
      homechecker={runner}
      verificationDate={verificationDate}
      backgroundColor="white"
      title={trans('value.proposition.features.title')}
    />
  );
};

ValuePropositionFeatures.propTypes = {
  listing: PropTypes.shape(ListingShape).isRequired
};

export default ValuePropositionFeatures;
